import { render, staticRenderFns } from "./client_download_document.vue?vue&type=template&id=20720776&scoped=true&"
import script from "./client_download_document.vue?vue&type=script&lang=ts&"
export * from "./client_download_document.vue?vue&type=script&lang=ts&"
import style0 from "./client_download_document.vue?vue&type=style&index=0&id=20720776&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20720776",
  null
  
)

export default component.exports